<template>
	<div>
		<div v-if="mandatory && !selectedSomething" class="error mb-2">
			{{ mandatory.errorMessage }}
		</div>
		<div v-if="nothing" class="mb-2">
			<b-form-checkbox
				v-model="nothingSelection"
				@change="onNothingChanged"
			>
				{{ nothing.label }}
			</b-form-checkbox>
		</div>
		<characteristic-tree-select-item
			v-for="characteristic in preparedCharacteristics"
			:key="characteristic.id"
			:characteristics="characteristics"
			:characteristic="characteristic"
			:selected="selected"
			@change="onSelectionChanged"
		/>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"
import {isDefined} from "@/helper/Value";
import * as Level from "@/helper/characteristic/Level"

export default {

	components: {
		Icon,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		characteristics: {
			type: Array,
			required: true,
		},
		mandatory: {
			type: Object,
			required: false,
		},
		nothing: {
			type: Object,
			required: false,
		},
		maxLevel: {
			type: Number,
			required: false,
		},
	},

	data ()
	{
		return {
			selected: this.value !== undefined ? this.value : undefined,
			nothingSelection: this.value === null,
		};
	},

	computed: {
		preparedCharacteristics ()
		{
			if (!isDefined(this.maxLevel))
			{
				return this.characteristics;
			}

			return Level.handle(this.characteristics, this.maxLevel);
		},
		selectedSomething ()
		{
			return isDefined(this.selected) || this.nothingSelection === true;
		},
	},

	methods: {
		onSelectionChanged (data)
		{
			this.nothingSelection = false;
			this.selected = data;

			this.emitChangeEvent();
		},
		onNothingChanged ()
		{
			this.selected = undefined;

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (this.nothingSelection)
			{
				this.$emit('input', null);
				return;
			}

			this.$emit('input', this.selected);
		}
	},
}
</script>